import { Box, Card, CardContent } from '@mui/material';
import { MprcContainer } from 'components';
import { EnrollmentComponentDto, TrainingComponentType } from 'generated/CoreApi_v1';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useEnrollmentViewContext } from '..';
import { launchSco } from '../Shared/EnrollmentActions';
import { EnrollmentComponents } from '../Shared/EnrollmentComponents';
import { useCourseEnrollmentViewContext } from './CourseEnrollmentView';

////////////////////////////////////////////////////////////////////////////

interface IProps {
    variant: "horizontal" | "vertical";
}

////////////////////////////////////////////////////////////////////////////

export const CourseEnrollmentViewSteps: React.FC<IProps> = (props) => {

    const { variant } = props;

    const { t } = useTranslation("lms");

    const { enrollment, onReload } = useEnrollmentViewContext();
    const { currentComponent, setCurrentComponent } = useCourseEnrollmentViewContext();

    const handleChangeComponent = (component: EnrollmentComponentDto) => {
        setCurrentComponent(component);
        //Se for Sco, inicia o curso imediatamente.
        if (component.componentType == TrainingComponentType.Sco) launchSco(enrollment.enrollmentId, component.scoComponent!, onReload, enrollment.readOnly);
    };

    return (
        <Box sx={variant == "vertical" ?
            { display: { xs: "none", sm: "none", md: "block" } } :
            { display: { xs: "block", sm: "block", md: "none" } }}
        >
            <MprcContainer>
                <Card>
                    {variant == "vertical" ?
                        <CardContent>
                            <EnrollmentComponents
                                title={t("Student.EnrollmentView.StepsTitle")}
                                items={enrollment.course!.components}
                                currentComponent={currentComponent}
                                onSelectComponent={handleChangeComponent}
                                variant="vertical"
                            />
                        </CardContent>
                        :
                        <EnrollmentComponents
                            items={enrollment.course!.components}
                            currentComponent={currentComponent}
                            onSelectComponent={handleChangeComponent}
                            variant="horizontal"
                        />
                    }
                </Card>
            </MprcContainer>
        </Box>
    );
};
